module.exports = __webpack_public_path__ + "static/panel-input-preview-8997844e24fd199efa0b0d4a6466aad9.svg";